import React from "react";

export const Solutions = (props) => {
  // Define custom URLs for each solution
  const getSolutionPath = (index) => {
    const paths = ['/telematics', '/dynamic-pricing', '/remote-assets', '/it-ot-harmonization'];
    return paths[index];
  };

  const handleSolutionClick = (e, index) => {
    if (getSolutionPath(index) === null) {
      e.preventDefault();
      alert('Coming Soon! This solution page is currently under development.');
    }
  };

  return (
    <div id="solutions" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Our Solutions</h2>
          <p>
            Browse some of the packaged solutions we can provide you right now. More are in the pipeline.
          </p>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.title}-${i}`} className="col-md-4">
                  <a 
                    href={getSolutionPath(i) || '#'}
                    target={getSolutionPath(i) ? "_blank" : "_self"}
                    rel={getSolutionPath(i) ? "noopener noreferrer" : ""}
                    className="solution-item"
                    onClick={(e) => handleSolutionClick(e, i)}
                    style={{ 
                      cursor: 'pointer',
                      textDecoration: 'none',
                      color: 'inherit',
                      display: 'block'
                    }}
                  >
                    <div className="solution-icon">
                      <i className={d.icon}></i>
                    </div>
                    <div className="solution-content">
                      <h3>{d.title}</h3>
                      <p className="solution-description">{d.description}</p>
                    </div>
                    <div className="solution-bottom">
                      <div className="solution-cta">
                        <span className="cta-text">Learn More & Get Started</span>
                        <i className="fa fa-arrow-right" style={{ marginLeft: '10px' }}></i>
                      </div>
                    </div>
                  </a>
                </div>
              ))
            : "Loading..."}
        </div>
      </div>
    </div>
  );
};